import React from 'react'
import {
  Box,
  Typography,
  Container,
  Button,
  useTheme
} from '@mui/material'
import { useHandleChangeRoute } from 'data/hooks'

const ContactSection = () => {
  const theme = useTheme()
  const handleChangeRoute = useHandleChangeRoute()

  return (
    <Box
      sx={{
        py: { xs: 8, sm: 12 },
        backgroundColor: theme.palette.background.dark,
        color: theme.palette.common.white,
        position: 'relative',
        clipPath: { xs: 'none', sm: 'polygon(0 0, 40% 0, 45% 40px, 55% 40px, 60% 0, 100% 0, 100% 100%, 0 100%)' },
        paddingTop: { xs: '40px', sm: '80px' }
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.25rem', md: '3rem' },
              fontWeight: 700,
              lineHeight: 1.2,
              color: theme.palette.common.white,
              mb: 3,
            }}
          >
            Ready to Find Your Next Role?
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: '1.15rem',
              lineHeight: 1.7,
              color: theme.palette.common.white,
              opacity: 0.85,
              mb: 5,
              maxWidth: '560px',
              mx: 'auto',
            }}
          >
            Join thousands of clinicians who found their next role through MyStethi. It takes 30 seconds to create an account.
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={() => handleChangeRoute('/register/physicians')()}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              px: 6,
              py: 2,
              fontSize: '1.1rem',
              textTransform: 'none',
              borderRadius: '8px',
              boxShadow: theme.palette.shadows.colored.primary,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                boxShadow: theme.palette.shadows.colored.primaryHover,
                transform: 'translateY(-2px)',
              },
            }}
          >
            Create an Account
          </Button>

          <Box sx={{ mt: 4 }}>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.9rem' }}
            >
              Are you a healthcare recruiter?{' '}
              <Typography
                component="span"
                onClick={() => handleChangeRoute('/recruiters')()}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  textUnderlineOffset: '3px',
                  fontSize: '0.9rem',
                  '&:hover': {
                    color: theme.palette.common.white,
                  },
                }}
              >
                Learn about MyStethi for health systems.
              </Typography>
            </Typography>
          </Box>

          <Box
            sx={{
              mt: { xs: 6, sm: 8 },
              pt: { xs: 4, sm: 6 },
              borderTop: `1px solid ${theme.palette.grey[800]}`
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontSize: '1rem', mb: 3, color: theme.palette.common.white, opacity: 0.8 }}
            >
              Have questions? Need help getting started?
            </Typography>

            <Button
              variant="contained"
              onClick={() => { window.location.href = '/contact' }}
              sx={{
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
                fontWeight: 700,
                px: { xs: 4, sm: 6 },
                py: { xs: 2, sm: 2.5 },
                fontSize: { xs: '1rem', sm: '1.1rem' },
                textTransform: 'none',
                borderRadius: '12px',
                boxShadow: theme.palette.shadows.colored.primary,
                border: `2px solid ${theme.palette.secondary.main}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: theme.palette.secondary.dark,
                  transform: 'translateY(-2px)',
                  boxShadow: theme.palette.shadows.colored.primaryHover,
                  borderColor: theme.palette.secondary.light,
                },
              }}
            >
              Contact Us
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default ContactSection
